import { isNylPilotAdvisor } from './pilotPrograms';

export const CONSUMER_SMS_MFA_FEATURE_FLAG =
  'consumerSmsMfa' as const satisfies AppConfigFeatureFlagKey;

interface ConsumerSmsMfaAvailabilityInput {
  advisorFeatureFlags?: FeatureFlags | null;
  appConfigFlags?: Pick<AppConfigFeatureFlags, typeof CONSUMER_SMS_MFA_FEATURE_FLAG> | null;
}

/**
 * Canonical gate for consumer SMS MFA.
 *
 * AppConfig provides the rollout/kill switch, while the persisted advisor cohort is the
 * authoritative NYL boundary. Requiring both prevents an `allAdvisors` AppConfig mistake from
 * enabling this identity mutation for other advisor programs.
 */
export function isConsumerSmsMfaEnabled({
  advisorFeatureFlags,
  appConfigFlags,
}: ConsumerSmsMfaAvailabilityInput): boolean {
  return (
    isNylPilotAdvisor(advisorFeatureFlags) &&
    appConfigFlags?.[CONSUMER_SMS_MFA_FEATURE_FLAG] === true
  );
}
